/* eslint-disable global-require */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom';

import './index.less';
import { applyMiddleware, createStore } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { ThemeProvider } from 'styled-components';
import { IntlProvider } from 'react-intl';
import history from './history';
import theme from './theme';
import * as serviceWorker from './serviceWorker';
import messages_es from './assets/translations/es.json';
import messages_en from './assets/translations/en.json';

import reducers from './state/reducers';
import sagas from './state/sagas';

import App from './App';

const middlewares = [];

if (process.env.NODE_ENV === 'development') {
  const { logger } = require('redux-logger');
  middlewares.push(logger);
}
const sagaMiddleware = createSagaMiddleware();
middlewares.push(sagaMiddleware);

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'navigation'],
};
const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(...middlewares)));
sagaMiddleware.run(sagas);
const persistor = persistStore(store);

const language = navigator.language.split(/[-_]/)[0];
const messages = {
  en: messages_en,
  es: messages_es,
};

const token = window.location.hash.substring(window.location.hash.lastIndexOf('/') + 1, window.location.hash.length);
localStorage.setItem('token', token);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <IntlProvider locale={language} messages={messages[language]}>
          <App history={history} />
        </IntlProvider>
      </PersistGate>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root'),
);

serviceWorker.unregister();
